import { CommonSuspense } from '../../common/components/common-suspense.tsx';
import { AccountScreenProtector } from '../../common/components/screen-protectors/account-screen-protector.tsx';

import { AccountsBeginJourneyScreenLazy } from '../screens/accounts/accounts-begin-journey.screen.lazy.tsx';
import { AccountsCreateProfileScreenLazy } from '../screens/accounts/accounts-create-profile.screen.lazy.tsx';
import { AccountsManageProfileScreenLazy } from '../screens/accounts/accounts-manage-profile.screen.lazy.tsx';

export const AccountsRouter = [
  {
    path: '/accounts/create-profile',
    element: (
      <CommonSuspense>
        <AccountScreenProtector>
          <AccountsCreateProfileScreenLazy />
        </AccountScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/accounts/begin-journey',
    element: (
      <CommonSuspense>
        <AccountScreenProtector>
          <AccountsBeginJourneyScreenLazy />
        </AccountScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/accounts/manage-profile',
    element: (
      <CommonSuspense>
        <AccountScreenProtector>
          <AccountsManageProfileScreenLazy />
        </AccountScreenProtector>
      </CommonSuspense>
    ),
  },
];
